/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CommunicationDirectionEnum = {
    Outbound: 'OUTBOUND',
    Inbound: 'INBOUND'
} as const;
export type CommunicationDirectionEnum = typeof CommunicationDirectionEnum[keyof typeof CommunicationDirectionEnum];

